import type { FC } from "react";
import type { InputProps } from "../../DynamicInput";
import { DateInput as SharedDateInput } from "../../shared/DateInput";
import { pickerInlineInputStateStyles } from "./InlineInputState";

type DateProps = InputProps<string>;
export const DateInput: FC<DateProps> = ({ ...props }) => (
  <SharedDateInput {...props} inlineInputStateStyles={pickerInlineInputStateStyles} />
);
